import React from 'react';
import { Card } from '@/components/shared/card';
import ValueSlider from './ValueSlider';
import { Weights } from '@/types/opportunity';

interface ChallengeFactorsCardProps {
  weights: Weights;
  onWeightChange: (key: keyof Weights, value: number[]) => void;
}

const challengeFactors = [
  { 
    key: 'CostAndEffort', 
    label: 'Cost and Effort',
    tooltip: "Implementation costs including software, training, and staff time required for deployment"
  },
  { 
    key: 'Risk', 
    label: 'Risk',
    tooltip: "Potential challenges including technical issues, user adoption, and integration complexity"
  },
  { 
    key: 'Complexity', 
    label: 'Complexity',
    tooltip: "Level of technical sophistication and organizational change management required"
  },
];

const ChallengeFactorsCard = ({ weights, onWeightChange }: ChallengeFactorsCardProps) => {
  return (
    <Card className="p-8">
      <h3 className="text-2xl md:text-3xl font-semibold mb-4">What are you most keen to minimize?</h3>
      <p className="text-base md:text-lg text-gray-500 mb-8">
        Slide right for higher sensitivity to challenges. This helps filter out solutions that might be too risky or complex.
      </p>
      <div className="space-y-12">
        {challengeFactors.map(({ key, label, tooltip }) => (
          <ValueSlider
            key={key}
            label={label}
            tooltip={tooltip}
            value={weights[key as keyof typeof weights]}
            onChange={(value) => onWeightChange(key as keyof typeof weights, value)}
            isChallengeMetric={true}
          />
        ))}
      </div>
    </Card>
  );
};

export default ChallengeFactorsCard;